"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = getTypeFromAsset;

var _fileTypes = require("../constants/fileTypes"),
    _fonts = _interopRequireDefault(require("../constants/fonts"));

function parseMetaData(a) {
  try {
    return "string" == typeof a ? JSON.parse(a) : a || {};
  } catch (b) {
    return a || {};
  }
}

function getTypeFromFileName(a) {
  var b = a.filename;

  try {
    if (!b) return _fileTypes.OTHER;
    var c = b.match(/\.[0-9a-z]+$/i);
    if (!c || !c.length) return _fileTypes.OTHER;
    var d = c[0];
    return _fonts["default"].includes(d) ? _fileTypes.FONT : _fileTypes.OTHER;
  } catch (a) {
    return _fileTypes.OTHER;
  }
}

function getTypeFromAsset(a) {
  var b = a.metaData,
      c = a.filename,
      d = parseMetaData(b),
      e = d.type;
  return e ? e.includes("image/heic") ? _fileTypes.HEIC : e.includes("image/") ? _fileTypes.IMAGE : e.includes("video/") ? _fileTypes.VIDEO : e.includes("audio/") ? _fileTypes.AUDIO : e.includes("font/") ? _fileTypes.FONT : _fileTypes.OTHER : getTypeFromFileName({
    filename: c
  });
}